interface ICustomerSupport {
  mail: string;
  subject: string;
}

export const SUPPORT: ICustomerSupport = {
  mail: 'merchantconnect@akzonobel.com',
  subject: 'Dulux Connect for Merchants: general user query',
};
